import ApplicationCooLayout from '../../layout/application-coo-layout';
import { SectionCard } from '../../components/card';
import { P2Alert, P2TextDescription, P2TextLabel } from 'react-bootstrap-common-script';
import { useAppSelector } from '../../redux/hook';
import { TextSubheader } from '../../components/text/text-subheader';
import { useGetApplicationDetailQuery } from '../../redux/services/getStageE';
import { useGetApplicationUuid } from '../../hooks/useGetApplicationUuid';
import { Helpers } from '../../utils/helper';

const CompletedApplication = () => {
  // TODO: Update HDB Website
  const startApplicationFormData = useAppSelector((state) => state.app.ApplicationStartSlice.formData);
  const address = startApplicationFormData?.selected_hdb_property?.address;

  const application_id = useGetApplicationUuid();
  const singpassToken = useAppSelector((state) => state.auth.AuthenticationSlice.singpassToken);
  const loginUser = useAppSelector((state) => state.auth.AuthenticationSlice.loginUser);

  const {
    data: applicationDetail,
    isLoading: applicationDetailIsLoading,
    isError: applicationDetailIsError,
  } = useGetApplicationDetailQuery({
    application_id: application_id ?? '0',
    uinfin: loginUser?.uinfin ?? '',
    singpass_token: singpassToken ?? '',
  });

  return (
    <ApplicationCooLayout>
      <div className='polymer-application-coo__wrapper cpf-wrapper'>
        <TextSubheader subheaderMain='Completed Application' subheaderSub={address} paddingLeftRight={42} />

        <div className='d-flex justify-content-center'>
          <SectionCard
            required={false}
            className='flex-fill'
            titleChildren={<P2TextDescription title={'Completed Application'} />}
            contentChildren={
              <div className='polymer-stage-e'>
                <div className='d-flex flex-column gap-4 mx-4 mb-4'>
                  <P2TextDescription
                    color='#333'
                    description_margin={0}
                    description={`Your application for change in flat ownership has been successfully completed on ${
                      Helpers.formatDate(applicationDetail?.legal_doc_signed_date) ?? ''
                    }`}
                  />
                  <P2Alert
                    withBorder={true}
                    variant='info'
                    style={{ background: 'white' }}
                    text={
                      <p>
                        {' '}
                        You may check{' '}
                        <a href='' target='_blank' rel='noreferrer' className='polymer-text-links'>
                          My HDB Page
                        </a>{' '}
                        for the updated ownership record.
                      </p>
                    }
                  />
                </div>
              </div>
            }
          />
        </div>
      </div>
    </ApplicationCooLayout>
  );
};

export default CompletedApplication;
